import Store from 'store/store';
import { addClass, removeClass } from 'utils/utils';

function prevDef(evt) {
	evt.preventDefault();
}

Store.on('SHOW_CAL_REMIND', (customData) => {
	Store.get().set({ calRemindOpen: customData || true });

	Store.emit('SET_HEADER_ACTION', {
		icon: 'close',
		action: () => Store.emit('CLOSE_CAL_REMIND'),
		tag: 'closeCalRemind'
	});

	addClass(document.body, 'locked');
	document.body.addEventListener('touchmove', prevDef, { passive: false });
});

Store.on('CLOSE_CAL_REMIND', () => {
	Store.get().set({ calRemindOpen: false });

	Store.emit('REMOVE_HEADER_ACTIONS', 'closeCalRemind');

	removeClass(document.body, 'locked');
	document.body.removeEventListener('touchmove', prevDef, { passive: false });
});

Store.on('CLOSE_ALL_OVERLAYS', () => {
	Store.emit('CLOSE_CAL_REMIND');
});
